import React from 'react'
import Box from '@mui/material/Box'
import palette from '../../theme/definitions/palette'

const layoutSx = (hasConnectorComponentStyle = false) =>
  ({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: 1,
    minHeight: 0,
    pt: hasConnectorComponentStyle ? 2 : 4,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    '& .hg-flows-container:last-child > .hotglue-w-MuiBox-root > hr': {
      display: 'none',
    },
  }) as const

const scrollbarSx = {
  '&::-webkit-scrollbar': {
    width: 8,
    margin: '4px 0',
  },
  '&::-webkit-scrollbar-track': {
    background: palette.common.divider,
    borderRadius: 4,
  },
  '&::-webkit-scrollbar-thumb': {
    background: palette.common.outline,
    borderRadius: 4,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: palette.text.tertiary,
  },
} as const

/** Shared Paper styles for the connections panel (V2/V3 widget wrapper). */
export const connectionsPanelSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  flex: 1,
  minHeight: 0,
  p: 4,
  width: '100%',
  overflow: 'auto',
  ...scrollbarSx,
} as const

/** Panel + scroll area for layouts with a fixed header (e.g. search bar). Scrollbar only on the content area. */
export const connectionsPanelWithScrollAreaSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  flex: 1,
  minHeight: 0,
  p: 4,
  width: '100%',
} as const

export const connectionsScrollAreaSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  ...scrollbarSx,
} as const

/** Full-area panel while the widget loads; matches connections column fill. */
export const connectionsPanelLoadingSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  flex: 1,
  minHeight: 0,
  width: '100%',
  p: 4,
  alignItems: 'center',
  justifyContent: 'center',
} as const

/** Compact centered card for errors; use with ConnectionsLayout. */
export const paperCardSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignSelf: 'center',
  p: 4,
  width: '100%',
  maxWidth: 480,
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 200,
} as const

type Props = {
  children: React.ReactNode
  hasConnectorComponentStyle?: boolean
}

export function ConnectionsLayout({
  children,
  hasConnectorComponentStyle = false,
}: Props) {
  return <Box sx={layoutSx(hasConnectorComponentStyle)}>{children}</Box>
}
